<template>
  <div class="flex-row flex__left">
    <el-button v-show="checkButtonApprover()" size="medium" class="
        flex-row flex__center
        margin-right-15
        addDocs
        btn-none__border
        color__black
      " @click="isOpenAddCoordinatorsDialog = true" v-if="
        isAbleToUpdate &&
        (listUserApprover.length !== 1 || type === 'receiver' || !config) &&
        !childIndex
      ">
      <span class="flex-row flex__center">
        <i class="fas fa-user-plus font-size__small color__cyan"></i>
        &nbsp;Thêm
      </span>
    </el-button>

    <!-- <el-popover trigger="hover" placement="top" width="500"> -->
    <!-- <el-table
        :data="coordinators"
        style="width: 100%"
        size="medium"
        :show-header="false"
        max-height="300"
        stripe
      >
        <el-table-column type="index"></el-table-column>

        <el-table-column show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ customLabelSelectPeople(scope.row) }}</span>
          </template>
        </el-table-column>

        <el-table-column width="60" align="left" v-if="isAbleToUpdate">
          <template slot-scope="scope">
            <i
              class="el-icon-circle-close margin-left-10 margin-right-10 font-size__large color__red clickable"
              @click="removeCoordinator(scope.row)"
            ></i>
          </template>
        </el-table-column>
      </el-table> -->

    <div slot="reference" class="list-people margin-right-10">
      <div v-for="coordinator in (coordinators || []).slice(0, 3)" :key="coordinator.id" class="item flex-row" :title="
        coordinator.fullName +
        ` (${coordinator.positionName}-${coordinator.deptName})`
      " style="margin-right: 10px">
        <div v-if="coordinator.url" class="avatar_bg"></div>
        <i v-else style="font-size: 28px" class="cellIcon color__silver fas fa-user-circle"></i>
        <!-- <div v-else class="avatar_fake flex-row flex__center">
          {{ coordinator.fullName | buildShortNameFilter }}
        </div> -->
        <div style="margin-left: 5px" class="flex-row flex__center">
          {{ coordinator.fullName }}
        </div>
      </div>
      <div
        v-show="coordinators && coordinators.length > 3"
        class="item avatar_fake flex-row flex__center"
        @click="showAllCoordinators"
        style="cursor: pointer"
      >
        +{{ coordinators.length - 3 }}
      </div>

      <!-- Modal List More Component -->
      <modal-list-more
        :isOpen="isModalListMoreVisible"
        :type="type"
        :coordinators="coordinators"
        @closeDialog="isModalListMoreVisible = false"
      ></modal-list-more>
    </div>
    <!-- </el-popover> -->

    <dialog-add-people :isOpen="isOpenAddCoordinatorsDialog" :coordinators="coordinators || []" :type="type"
      :config="config" :listUserApprover="listUserApprover" v-if="isEnableAddCoordinatorsDialog"
      @closed="isEnableAddCoordinatorsDialog = false" @closeDialog="closeAddCoordinatorsDialog"
      @submit="addCoordinators" />
  </div>
</template>

<script>
import buildShortNameFilter from "../../../../filters/buildShortNameFilter";
import DialogAddPeople from "./dialog-add-peopleV2.vue";
import h from "../../../../services/h";
import userDeptRoleViewService from "../../../../services/userDeptRoleViewService";
import ModalListMore from '../../../common/modal-list-more.vue';
// import { type } from "os";

export default {
  name: "task-coodinators",
  components: { DialogAddPeople, ModalListMore },
  filters: { buildShortNameFilter },
  props: [
    "selectedItems",
    "isAbleToUpdate",
    "type",
    "config",
    "defaultApprover",
    "receiver",
    "childIndex",
    "currentItem",
    "allUserDeptRoleViews"
  ],
  data() {
    return {
      LANH_DAO_TRUC_TIEP: 1,
      coordinators: [],
      isOpenAddCoordinatorsDialog: false,
      isEnableAddCoordinatorsDialog: false,
      listUserApprover: [],
      localAllUserDeptRoleViews: this.allUserDeptRoleViews && this.allUserDeptRoleViews.length > 0
      ? [...this.allUserDeptRoleViews]
      : [],
      isModalListMoreVisible: false,
    };
  },

  computed: {
    coordinatorIds() {
      return h.collect(this.coordinators, (item) => item.id);
    },
  },

  watch: {
    isOpenAddCoordinatorsDialog(newValue) {
      newValue && (this.isEnableAddCoordinatorsDialog = newValue);
    },

    selectedItems() {
      this.reloadData();
    },

    config() {
      this.reloadData();
    },

    receiver() {
      this.reloadData();
    },
  },

  async created() {
    if (this.allUserDeptRoleViews) {
      this.localAllUserDeptRoleViews = this.allUserDeptRoleViews;
    } else {
      await this.loadAssigners();
    }
    await this.reloadData();
  },

  methods: {
    checkButtonApprover() {
      if (this.type !== 'approver') {
        return true;
      }
      if (this.config && this.config.type === this.LANH_DAO_TRUC_TIEP) {
        return false;
      }
      return true;
    },
    reloadData() {
      // isAbleToUpdate &&
      //   (listUserApprover.length !== 1 || type === 'receiver') &&
      //   !childIndex
      this.coordinators = this.selectedItems ? [...this.selectedItems] : [];
      if (
        !this.selectedItems ||
        !this.selectedItems.length ||
        this.childIndex ||
        (!this.childIndex && this.config && !this.currentItem)
      ) {
        if (this.receiver && this.receiver.length) {
          this.coordinators = this.allUserDeptRoleViews.filter(
            (x) => this.receiver.indexOf(x.userId) !== -1
          );
        } else if (this.config) {
          if (this.config.type === 1) {
            this.coordinators = this.defaultApprover || [];
            this.listUserApprover = this.defaultApprover || [];
          } else if (this.config.userIds) {
            this.coordinators = this.allUserDeptRoleViews.filter(
              (x) => this.config.userIds.indexOf(x.userId) !== -1
            );
            this.listUserApprover = this.coordinators;
          }
        } else {
          this.listUserApprover = [];
        }
      } else {
        // this.listUserApprover = this.defaultApprover;
      }
    },

    async loadAssigners() {
      if (this.allUserDeptRoleViews.length > 0) return;
      const res = userDeptRoleViewService.findAllFiltered().then((response) => {
        this.allUserDeptRoleViews = response.data
          .filter(
            (item) =>
              item.isDefaultRole === 1
          )
          .map((item) => {
              return {
                ...item,
                label:
                  item.fullName + ` (${item.positionName} - ${item.deptName})`,
                selected: true,
              };
          });
      });
      this.localAllUserDeptRoleViews = this.allUserDeptRoleViews;
      return res;
    },

    getData() {
      return this.coordinators;
    },

    removeCoordinator(coordinator) {
      this.coordinators.splice(this.coordinators.indexOf(coordinator), 1);
    },

    customLabelSelectPeople(userDeptRoleView) {
      return `${userDeptRoleView.fullName} (${userDeptRoleView.positionName} - ${userDeptRoleView.deptName})`;
    },

    closeAddCoordinatorsDialog() {
      this.isOpenAddCoordinatorsDialog = false;
    },

    addCoordinators(event) {
      this.coordinators = [];
      h.each(event.userDeptRoleViews, (userDeptRoleView) => {
        if (
          h.exists(
            this.coordinators,
            (coordinator) => coordinator.id === userDeptRoleView.id
          )
        )
          return;
        this.coordinators.push(userDeptRoleView);
      });
      this.isOpenAddCoordinatorsDialog = false;
      this.$emit("clearValidateFiled", { varName: this.type });
    },

    showAllCoordinators() {
      this.isModalListMoreVisible = true;
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/office/doc/components/task-coodinators.vue